import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { DataService } from '../../services/data.service';

@Component({
    template: `<div></div>`,
})

export class SSOLoginComponent implements OnInit {
    token: string;
    search: string;
    eventTitle: string;
    //queryParams:any;

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private dataservice: DataService
        //private authenticationService: AuthenticationService,
        //private alertService: AlertService
    ) { }

    ngOnInit() {
        //this.queryParams = this.route.snapshot.queryParams;
        this.token = this.route.snapshot.params['token'];
        this.search = this.route.snapshot.params['search'];
        this.eventTitle = this.route.snapshot.params['title'];
        //this.authenticationService.ssoLogin(this.key,this.title,this.host);
        this.dataservice.authenticatesso(this.token).subscribe(
            data => {
                //console.log(this);
                if (data) {
                    if (this.search == 'null')
                    {
                        let url = 'experienceReport/' + this.eventTitle;
                        this.router.navigate([url], { queryParams: { search:  '' }});
                    }
                    else
                    {
                        let url = 'experienceReport/' + this.eventTitle;
                        this.router.navigate([url], { queryParams: { search:  this.search }});
                    }

                }
                else
                    this.router.navigate(['login']);
            },
            error => {
                //console.log("Error login");
                this.router.navigate(['login']);
            });

    }

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/viewsmodule/ssologin/ssologin.component.ts